import { render, staticRenderFns } from "./PollMatrixEditorMobile.vue?vue&type=template&id=b799683e&scoped=true"
import script from "./PollMatrixEditorMobile.vue?vue&type=script&lang=js"
export * from "./PollMatrixEditorMobile.vue?vue&type=script&lang=js"
import style0 from "./PollMatrixEditorMobile.vue?vue&type=style&index=0&id=b799683e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b799683e",
  null
  
)

export default component.exports